<template>
  <footer class="footer">
    <div class="container">
      <main>
        <div class="footer_left">
          <div class="img">
            <img v-if="config.foot_logo" :src="$baseURL + config.foot_logo" alt="" />
          </div>
          <div class="callMe">
            <a class="iconfont icon-a-Group23" :href="'tel:' + config.tel">{{ config.tel }}</a>
            <a class="iconfont icon-Vector" :href="'tomail:' + config.email">{{ config.email }}</a>
            <div class="iconfont icon-a-Group17">{{ config.address }}</div>
          </div>
        </div>
        <div class="footer_right">
          <div class="footer_item">
            <router-link :to="{ path: '/about' }">ABOUT</router-link>
            <router-link :to="{ path: '/about/js' }">Company Introduction</router-link>
            <router-link :to="{ path: '/about/zz' }">Honor</router-link>
            <router-link :to="{ path: '/about/lc' }">Development History</router-link>
            <router-link :to="{ path: '/about/hb' }">Cooperative Partner</router-link>
          </div>
          <div class="footer_item">
            <router-link :to="{ path: '/product' }">PRODUCT</router-link>
            <router-link v-for="item in foot.pro" :key="item.id"
              :to="{ name: 'productInfo', params: { id: item.id } }">{{ item.title }}</router-link>
          </div>
          <div class="footer_item">
            <router-link :to="{ path: '/solution' }">SOLUTION</router-link>
            <router-link v-for="item in foot.solution" :key="item.id"
              :to="{ name: 'Solution', params: { id: item.id } }">{{ item.title }}</router-link>
          </div>
          <div class="footer_item">
            <router-link :to="{ path: '/case' }">CASE</router-link>
            <router-link v-for="item in foot.case" :key="item.id" :to="{ name: 'caseInfo', params: { id: item.id } }">{{
              item.title }}</router-link>
          </div>
          <div class="footer_item">
            <router-link :to="{ path: '/news' }">NEWS</router-link>
            <router-link v-for="item in newsCate" :key="item.id"
              :to="{ path: '/news/list', query: { cid: item.id } }">{{ item.cat_name }}</router-link>
          </div>
          <div class="footer_item">
            <router-link :to="{ path: '/countact' }">CONTACT</router-link>
            <router-link :to="{ path: '/countact/ln' }">Talent Concept</router-link>
            <router-link :to="{ path: '/countact/zp' }">Recruiting</router-link>
            <router-link :to="{ path: '/countact/lx' }">Contact Us</router-link>
          </div>
        </div>
      </main>
      <div class="footer_bottom">
        <a href="#">{{ config.copy_right }} </a>
        <a href="#">{{ config.icp }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    config: { type: Object },
    foot: { type: Object },
    newsCate: { type: Object },
  },
};
</script>

<style lang="less" scoped>
.footer {
  padding: 70px 0 5px;
  background: #0b0b0d;

  main {
    display: flex;
    justify-content: space-between;

    .footer_left {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .img {
        width: 50%;

        img {
          width: 100%;
        }
      }

      .callMe {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        a,
        div {
          color: #fff;
          font-size: 14px;
          line-height: 2.5;
          font-family: Regular !important;

          &::before {
            font-family: iconfont !important;
            width: 27px;
            display: inline-block;
            text-align: center;
          }

          &:nth-child(2) {
            &::before {
              font-size: 12px;
            }
          }
        }
      }
    }

    .footer_right {
      flex: 2.5;
      display: flex;
      justify-content: space-between;

      .footer_item {
        a:first-child {
          display: block;
          font-size: 18px;
          color: #fff;
          font-family: Medium;
          padding-bottom: 30px;
          position: relative;

          &::after {
            content: "";
            width: 1em;
            height: 3px;
            background: var(--themeColor2);
            position: absolute;
            left: 0;
            bottom: 15px;
          }
        }

        a:not(:first-child) {
          display: block;
          line-height: 1.8;
          font-size: 14px;
          color: #999;
          transition: all 0.3s;

          &:hover {
            transform: translateX(2px);
            color: var(--themeColor);
          }
        }
      }
    }
  }

  .footer_bottom {
    text-align: center;
    margin-top: 70px;
    font-size: 12px;

    span,
    a {
      color: #999;
    }

    a:hover {
      color: var(--themeColor);
    }
  }
}

@media (max-width: 1000px) {
  .footer {
    main {
      display: block;

      .footer_left {
        margin-bottom: 20px;

        .img {
          width: 30%;
        }
      }
    }
  }
}

@media (max-width: 600px) {
  .footer {
    padding-top: 40px;

    main {
      .footer_right {
        display: none;
      }
    }

    .footer_bottom {
      margin-top: 20px;
    }
  }
}
</style>